import { createSelector } from '@reduxjs/toolkit';
import type { BusinessModel } from './types';
import type { RootState } from '../store';

export const selectBusinessById = createSelector(
    [
        (state: RootState) => state.business.records,
        (state: RootState, businessId: BusinessModel['publicId'] | undefined): string | undefined =>
            businessId,
    ],
    (records, businessId) => (businessId ? records[businessId] : undefined),
);

export const selectBusinessCollection = createSelector(
    [
        (state: RootState) => state,
        (state: RootState, namespace: string) => state.business.collections[namespace]?.identifiers,
    ],
    (draft, identifiers) =>
        (identifiers || [])
            .map((id: string) => selectBusinessById(draft, id))
            .filter(Boolean) as BusinessModel[],
);

export const selectBusinessCollectionLoading = createSelector(
    [(state: RootState, namespace: string) => state.business.collections[namespace]],
    (draft) => draft?.isLoading ?? false,
);

export const selectBusinessCollectionFilters = createSelector(
    [(state: RootState, namespace: string) => state.business.collections[namespace]],
    (draft): Record<string, any> => draft?.filters ?? {},
);

export const selectIsBusinessReported = createSelector(
    [
        (state: RootState) => state.business.reportedBusinesses,
        (state: RootState, businessId: string): string => businessId,
    ],
    (reportedBusinesses, businessId): boolean => Boolean(reportedBusinesses[businessId]),
);
